<div class="scroll-sticky-top-container" #containerElem>
    <div class="sticky-anchor" #anchorElem></div>
    <div class="sticky-content" #contentElem>
        <ng-content></ng-content>
    </div>
</div>
